import React from "react";
import { NotFoundComponent } from "../../component";

const Index = () => {
  return <NotFoundComponent />;
};

export default Index;
